export default {
  SET_DEFAULTICONS: 'setDefaulticons',
  SET_SELECTED_DEFAULTICON: 'setSelectedDefaulticon',
}
